export default __webpack_public_path__ + "static/media/StoreGRNentry.6c580590.svg";